import { render, staticRenderFns } from "./HeadBar.vue?vue&type=template&id=e06504f2&scoped=true"
import script from "./HeadBar.vue?vue&type=script&lang=js"
export * from "./HeadBar.vue?vue&type=script&lang=js"
import style0 from "./HeadBar.vue?vue&type=style&index=0&id=e06504f2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06504f2",
  null
  
)

export default component.exports